import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-slate-200 mt-auto" data-testid="footer">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <Activity className="h-6 w-6 text-primary" />
              <span className="text-xl font-manrope font-bold text-slate-900">Booking Vedamrita</span>
            </div>
            <p className="text-sm text-slate-600">
              Making healthcare appointments simple and accessible for everyone.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-manrope font-semibold text-slate-900 mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-slate-600 hover:text-primary transition-colors" data-testid="footer-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-slate-600 hover:text-primary transition-colors" data-testid="footer-book">
                  Book Appointment
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-slate-600 hover:text-primary transition-colors" data-testid="footer-dashboard">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/admin" className="text-slate-600 hover:text-primary transition-colors" data-testid="footer-admin">
                  Admin Panel
                </Link>
              </li>
            </ul>
          </div>

          {/* For Patients */}
          <div>
            <h3 className="font-manrope font-semibold text-slate-900 mb-4">For Patients</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/register" className="text-slate-600 hover:text-primary transition-colors" data-testid="footer-register">
                  Register
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-slate-600 hover:text-primary transition-colors" data-testid="footer-login">
                  Login
                </Link>
              </li>
              <li>
                <a href="#" className="text-slate-600 hover:text-primary transition-colors">
                  Find Doctors
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-600 hover:text-primary transition-colors">
                  Health Records
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-manrope font-semibold text-slate-900 mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-slate-600">
                <Mail className="h-4 w-4 text-primary" />
                <a href="mailto:info@vedamrita.com" className="hover:text-primary transition-colors">
                  info@vedamrita.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-slate-600">
                <Phone className="h-4 w-4 text-primary" />
                <a href="tel:+918570023400" className="hover:text-primary transition-colors">
                  +91 85700-23400
                </a>
              </li>
              <li className="flex items-start gap-2 text-slate-600">
                <MapPin className="h-4 w-4 text-primary mt-0.5" />
                <span>Hisar - Tohana Rd, near MRF Agency<br />Barwala, Haryana 125121</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-8 pt-8 text-center text-sm text-slate-600">
          <p>&copy; {currentYear} Vedamrita Ayurvedic Hospital. All rights reserved.</p>
          <div className="flex justify-center gap-6 mt-2">
            <Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-primary transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};